@mixin pgm-label-large-typography {
  font-family: var(--pgm-sys-typescale-label-large-font);
  font-size: var(--pgm-sys-typescale-label-large-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-label-large-weight);
  line-height: var(--pgm-sys-typescale-label-large-line-height);
  letter-spacing: var(--pgm-sys-typescale-label-large-tracking);
}

@mixin pgm-body-medium-typography {
  font-family: var(--pgm-sys-typescale-body-medium-font);
  font-size: var(--pgm-sys-typescale-body-medium-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-medium-weight);
  line-height: var(--pgm-sys-typescale-body-medium-line-height);
  letter-spacing: var(--pgm-sys-typescale-body-medium-tracking);
}

@mixin pgm-body-small-typography {
  font-family: var(--pgm-sys-typescale-body-small-font);
  font-size: var(--pgm-sys-typescale-body-small-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-small-weight);
  line-height: var(--pgm-sys-typescale-body-small-line-height);
  letter-spacing: var(--pgm-sys-typescale-body-small-tracking);
}

.itenContent,
.contentInformation,
.groupBody,
.extinticGroupBody,
.groupmentDebt,
.extinctGroupmentDebt,
.itemInscription {
  width: 100%;
  box-sizing: border-box;
  margin: var(--pgm-sys-spacing-0);
}

.itenContent {
  display: inline-grid;
}

.detailedInformations {
  height: auto;
}

.contentInformation {
  display: flex;
  flex-direction: column;
  max-height: none;
  overflow: visible;
  border: 0;
  outline: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.v2PaymentActions {
  position: absolute;
  top: calc(0px - var(--pgm-sys-spacing-12));
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--pgm-sys-spacing-2);
  height: var(--pgm-sys-spacing-12);
  min-height: var(--pgm-sys-spacing-12);
  margin: var(--pgm-sys-spacing-0);
}

.initialInformation {
  display: none;
}

.groupBody,
.extinticGroupBody,
.groupmentDebt,
.extinctGroupmentDebt {
  border: 0;
  border-radius: 0;
  background: transparent;
}

.groupments,
.negotiationGroupment,
.extinctGroupment {
  display: grid;
  grid-template-columns: var(--pgm-sys-spacing-12) minmax(0, 1fr) auto var(--pgm-sys-spacing-12);
  align-items: center;
  width: 100%;
  height: var(--pgm-sys-spacing-12);
  min-height: var(--pgm-sys-spacing-12);
  box-sizing: border-box;
  padding: var(--pgm-sys-spacing-0);
  border: 0;
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  color: var(--pgm-sys-color-on-surface);
}

.groupments > div,
.negotiationGroupment > div,
.extinctGroupment > div {
  margin: var(--pgm-sys-spacing-0);
}

.groupments:hover,
.negotiationGroupment:hover,
.extinctGroupment:hover {
  background: color-mix(in srgb, var(--pgm-sys-color-on-surface) 8%, transparent);
}

.groupToggleButton {
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);

  justify-self: center;
}

.groupToggleButton :global(.material-symbols-sharp) {
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-spacing-5);
}

.groupSelectionCheckbox {
  position: relative;
  justify-self: center;
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  margin: var(--pgm-sys-spacing-0);
  appearance: none;
  border: 2px solid var(--pgm-sys-color-on-surface-variant);
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
}

.groupSelectionCheckbox:checked {
  border-color: var(--pgm-sys-color-primary);
  background: var(--pgm-sys-color-primary);
}

.groupSelectionCheckbox:checked::after {
  position: absolute;
  top: 0;
  left: var(--pgm-sys-spacing-1);
  width: var(--pgm-sys-spacing-1);
  height: var(--pgm-sys-spacing-2);
  border: solid var(--pgm-sys-color-on-primary);
  border-width: 0 2px 2px 0;
  content: "";
  transform: rotate(45deg);
}

.groupSelectionCheckbox:focus-visible {
  outline: 2px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.groupSelectionCheckbox:disabled {
  cursor: default;
  opacity: 0.38;
}

.groupmentInformations {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.groupmentInformations > strong,
.groupmentInformations > span {
  margin: var(--pgm-sys-spacing-0);
}

.groumpentValues,
.groumpentValuesWithRefis {
  display: flex;
  align-items: center;
  margin: var(--pgm-sys-spacing-0);
}

.groupGeneralValue,
.groupmentValuesWithREFIS,
:global(#refisValueInfo) {
  display: flex;
  align-items: center;
}

.groupGeneralValue {
  gap: var(--pgm-sys-spacing-1);
  margin: var(--pgm-sys-spacing-0);
}

.groupmentValuesWithREFIS {
  flex-direction: column;
}

:global(#refisValueInfo) {
  justify-content: flex-end;
}

:global(#dynamicGroupInfo),
:global(#dynamicGroupInfoREFIS) {
  margin: var(--pgm-sys-spacing-0);
}

.ifRefisEnabled {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 180px;
  margin-left: var(--pgm-sys-spacing-1);
  padding-inline: var(--pgm-sys-spacing-1);
  border-radius: 5px;
  background-color: var(--pgm-sys-color-primary);
}

.dynamicGroupHide,
.insciptionSelectedsInvisible {
  display: none;
}

.insciptionSelecteds {
  display: inline;
}

.totalSelected {
  color: var(--pgm-sys-color-on-surface-variant);
}

.requestedDate {
  margin-left: var(--pgm-sys-spacing-1);
}

.opennedNegotiation {
  display: inline-flex;
}

.contentInformation,
.contentInformation strong,
.contentInformation span:not(:global(.material-symbols-sharp)) {
  @include pgm-label-large-typography;
  color: var(--pgm-sys-color-on-surface);
}

.contentInformation .groumpentValues > div,
.contentInformation span.requestedDate {
  @include pgm-label-large-typography;
}

.contentInformation span.monetaryValue,
.contentInformation strong.balanceToLegalAction,
.contentInformation span.totalSelected {
  @include pgm-body-medium-typography;
  color: var(--pgm-sys-color-on-surface-variant);
}

.contentInformation span.negotiationUnavailableTag {
  @include pgm-body-small-typography;

  display: inline-flex;
  align-items: center;
  min-height: var(--pgm-sys-spacing-6);
  margin-left: var(--pgm-sys-spacing-5);
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-2);
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-primary-container);
  color: var(--pgm-sys-color-on-primary-container);
  white-space: nowrap;
}

/* Estados ainda usados pelas rotinas legadas de seleção. */
.extinticGroupBodySelected,
.extinctGroupmentSelected {
  background: transparent;
}

.selectAllButtonMarked {
  border-color: var(--pgm-sys-color-primary);
}

.clearAllSelections,
.installmentButton,
.ticketButton {
  display: flex;
}

.installmentButtonDisabled,
.ticketButtonDisabled {
  opacity: 0.38;
}

/* Conteúdo dos modais de parcelamento. */
.simulacao-parcelamento {
  padding: var(--pgm-sys-spacing-4);
}

.simulacao-parcelamento ul {
  padding-left: inherit;
  list-style: none;
}

.simulacao-parcelamento > h2 {
  margin-bottom: var(--pgm-sys-spacing-4);
  color: var(--pgm-sys-color-on-surface);
}

.simulacao-parcelamento > ol {
  margin: var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-5);
  padding: var(--pgm-sys-spacing-0);
  counter-reset: item;
}

.simulacao-parcelamento > ol > li {
  margin-bottom: var(--pgm-sys-spacing-3);
  padding-left: var(--pgm-sys-spacing-8);
  list-style-type: none;
  text-indent: calc(0px - var(--pgm-sys-spacing-8));
  counter-increment: item;
}

.simulacao-parcelamento > ol > li::before {
  display: inline-block;
  width: var(--pgm-sys-spacing-5);
  padding-right: var(--pgm-sys-spacing-2);
  font-weight: var(--pgm-sys-typescale-title-medium-weight);
  text-align: right;
  content: counter(item) ".";
}

.simulacao-parcelamento > .instrucoes-parcelamento {
  margin: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-3);
}

.simulacao-parcelamento > .infos {
  color: var(--pgm-sys-color-secondary);
}

.simulacao-parcelamento > .actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--pgm-sys-spacing-3);
}

.modalActionButton {
  margin-right: var(--pgm-sys-spacing-3);
}

.simulacao-parcelamento > .parcelas {
  margin-bottom: var(--pgm-sys-spacing-5);
}

.simulacao-parcelamento > .parcelas > .installmentOption {
  display: flex;
  width: 100%;
  margin-bottom: var(--pgm-sys-spacing-1);
  padding: var(--pgm-sys-spacing-1);
  border: 2px solid var(--pgm-sys-color-surface-container-low);
  border-radius: var(--pgm-sys-spacing-1);
  outline: transparent;
  background: var(--pgm-sys-color-surface-container-low);
  text-align: left;
}

.simulacao-parcelamento > .parcelas > .installmentOption:hover,
.simulacao-parcelamento > .parcelas > .installmentOption:focus,
.simulacao-parcelamento > .parcelas > .installmentOption:active {
  border-color: var(--pgm-sys-color-surface-container-highest);
  background: var(--pgm-sys-color-surface-container-highest);
}

.simulacao-parcelamento > .parcelas > .installmentOption.selected {
  border-color: var(--pgm-sys-color-secondary);
}

.simulacao-parcelamento .quantidade {
  display: inline-block;
  width: 30px;
  margin-right: var(--pgm-sys-spacing-3);
  font-weight: var(--pgm-sys-typescale-title-medium-weight);
  text-align: right;
}

.simulacao-parcelamento .descricao {
  flex: 1;
}

.simulacao-parcelamento .desconto {
  text-align: right;
}

.modal-parcelamento {
  padding: var(--pgm-sys-spacing-4);
  text-align: center;
}

.warning {
  max-width: 355px;
  max-height: 21px;
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-secondary);
  color: var(--pgm-sys-color-on-secondary);
}

.warning > svg {
  margin-left: var(--pgm-sys-spacing-1);
}

.warning > span {
  margin-left: var(--pgm-sys-spacing-1);
}

.termsTittle {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--pgm-sys-spacing-5);
  padding-top: var(--pgm-sys-spacing-4);
}

.termsTittle > h6 {
  color: var(--pgm-sys-color-on-surface);
}

.termContent {
  display: flex;
  flex-wrap: wrap;
}

.termTheme {
  padding-bottom: var(--pgm-sys-spacing-4);
  color: var(--pgm-sys-color-on-surface-variant);
}

.acceptBox {
  display: flex;
  justify-content: flex-end;
  padding-block: var(--pgm-sys-spacing-5) var(--pgm-sys-spacing-4);
}

.acceptBox > span {
  margin-left: var(--pgm-sys-spacing-1);
}

.terTextContent > p {
  margin: calc(0px - var(--pgm-sys-spacing-1)) var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface-variant);
  text-align: justify;
  text-indent: 140px;
}

.inputEmail {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-block: calc(0px - var(--pgm-sys-spacing-2)) var(--pgm-sys-spacing-5);
}

.inputEmail > span {
  margin-right: calc((var(--pgm-sys-spacing-20) * 2) + var(--pgm-sys-spacing-5));
  color: var(--pgm-sys-color-on-surface-variant);
}

.inputEmail > input {
  width: 300px;
  height: 30px;
  padding-left: var(--pgm-sys-spacing-1);
  border: thin solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-1);
  color: var(--pgm-sys-color-on-surface-variant);
}

.emailForCodeInput::-webkit-inner-spin-button {
  margin: var(--pgm-sys-spacing-0);
  -webkit-appearance: none;
}

.totalTributeBalance,
.totalTributeBalanceRefis {
  margin-left: var(--pgm-sys-spacing-3);
  padding-block: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-5);
  color: var(--pgm-sys-color-on-surface);
}

.refisLabel {
  padding: var(--pgm-sys-spacing-1);
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-primary);
}

.balanceValue {
  color: var(--pgm-sys-color-secondary);
  font-weight: var(--pgm-sys-typescale-title-medium-weight);
}

.valueWithoutDiscount {
  margin-left: var(--pgm-sys-spacing-1);
}

@media (max-width: 768px) {
  .v2PaymentActions {
    position: static;
    flex-wrap: wrap;
    justify-content: flex-start;
    height: auto;
  }

  .groupments,
  .negotiationGroupment,
  .extinctGroupment {
    grid-template-columns: var(--pgm-sys-spacing-12) minmax(0, 1fr) var(--pgm-sys-spacing-12);
    height: auto;
    min-height: var(--pgm-sys-spacing-12);
  }

  .groumpentValues,
  .groumpentValuesWithRefis {
    grid-column: 2;
    flex-wrap: wrap;
    padding-bottom: var(--pgm-sys-spacing-2);
  }

  .groupSelectionCheckbox {
    grid-column: 3;
    grid-row: 1;
  }

  .inputEmail {
    align-items: stretch;
  }

  .inputEmail > span {
    margin-right: var(--pgm-sys-spacing-0);
  }

  .inputEmail > input {
    width: 100%;
  }
}
